import React from "react";
import ContentHeading from "@/components/content-heading";
import {container, heading, subheading } from "./styles/award-header"

const AwardsHeader: React.FC = () => {
    return (
        <section aria-label={"hearX Group awards white background"} title={"Awards won by hearX®"}>
            <div className={container}>
                <div className={heading}>
                    <ContentHeading
                        h="p"
                        className="mobile:justify-center tablet:justify-center"
                        backdropPosition="mobile:left-4 tablet:left-8"
                        fontSize="mobile:text-3xl tablet:text-5xl"
                        background="bg-primary bg-opacity-50"
                    >
                        Awards
                    </ContentHeading>
                    <p className={subheading}>
                        We are proud to have received various awards that recognise our hard work and commitment.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default AwardsHeader
